export const subscribePlaceOrder = `subscription SubscribePaceOrder($restaurant:String!){
    subscribePlaceOrder(restaurant:$restaurant){
      userId
      origin
      order{
        _id
        orderId
        restaurant{
          _id
          name
          image
          address
          location{coordinates}
        }
        deliveryAddress{
          location{coordinates}
          deliveryAddress
          details
          label
        }
        items{
          _id
          title
          description
          image
          quantity
          variation{
            _id
            title
            price
            discounted
          }
          addons{
            _id
            options{
              _id
              title
              description
              price
            }
            description
            title
            quantityMinimum
            quantityMaximum
          }
          specialInstructions
          isActive
          createdAt
          updatedAt
        }
        user{
          _id
          name
          phone
          email
        }
        paymentMethod
        paidAmount
        orderAmount
        orderStatus
        status
        paymentStatus
        reason
        isActive
        createdAt
        deliveryCharges
        rider{
          _id
          name
          username
          available
        }
    }
  }
  }`

export const subscriptionOrder = `subscription SubscriptionOrder($id:String!){
    subscriptionOrder(id:$id){
        _id
        orderStatus
        rider{
            _id
        }
    }
  }`

export const subscriptionRiderLocation = `subscription SubscriptionRiderLocation($riderId: String!) {
    subscriptionRiderLocation(riderId: $riderId) {
      _id
      name
      email
      username
      phone
      image
      available
      onDuty
      vehicleType
      isActive
      createdAt
      updatedAt
      location {
        coordinates
      }
      accountNumber
      currentWalletAmount
      totalWalletAmount
      withdrawnWalletAmount
    }
  }`

export const subscriptionDeliveryJob = `subscription SubscriptionDeliveryJob($zoneId: String!) {
    subscriptionDeliveryJob(zoneId: $zoneId) {
      zoneId
      origin
      deliveryJob {
        id
        groupId
        timezone
        status
        pickupTime
        completedAt
        acceptedAt
        startedAt
        deliveryWage
        lalamoveDeliveryFee
        distance
        isStacked
        vehicleType
        assignedAt
        titleMessage
        nextActionMessage
        inProgressStop
        riderId
        riderName
        riderPhone
        orderType
        zone {
          _id
        }
        orders {
          _id
          orderId
          orderStatus
        }
        stops {
          stopId
          type
          location {
            type
            coordinates
          }
          address
          details
          label
          deliveryInstructions
          neighbourhood
          estimatedTime
          status
          completedAt
          restaurantName
          restaurantPhone
          totalPackages
          customerName
          customerPhone
          itemCount
          orders {
            _id
            orderId
            orderStatus
          }
        }
      }
    }
  }`
